module.exports = __webpack_public_path__ + "static/media/ic_kid.b4dedd09.svg";